export default __webpack_public_path__ + "static/media/ethers.eaa073a1.png";